import { render, staticRenderFns } from "./policyPage.vue?vue&type=template&id=166dc6c8&scoped=true"
import script from "./policyPage.vue?vue&type=script&lang=js"
export * from "./policyPage.vue?vue&type=script&lang=js"
import style0 from "./policyPage.vue?vue&type=style&index=0&id=166dc6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166dc6c8",
  null
  
)

export default component.exports